import { blogs } from "../../data/blogs";

const SearchCategoryFilter = ({
  search,
  setSearch,
  category,
  setCategory,
}) => {
  const categories = [
    "All",
    ...new Set(blogs.map((blog) => blog.category)),
  ];

  return (
    <section className="py-12 bg-white">
      <div className="container-custom">

        <div className="grid md:grid-cols-2 gap-6">

          <input
            type="text"
            placeholder="Search blogs..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border border-gray-200 rounded-xl px-5 py-4 outline-none"
          />

          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="border border-gray-200 rounded-xl px-5 py-4 outline-none"
          >
            {categories.map((cat, index) => (
              <option key={index}>
                {cat}
              </option>
            ))}
          </select>

        </div>

      </div>
    </section>
  );
};

export default SearchCategoryFilter;